module.exports = __webpack_public_path__ + "media/images/alexander-b7d01fd4fbd265d4adda695c59d424f1.png";